export function getParentId(
  parent?: { id?: string | number } | null
): string | undefined {
  const parentId = parent?.id;

  if (parentId) {
    const parentIdParts = String(parentId).split('.');
    if (parentIdParts.length > 1) {
      const firstPart = parentIdParts[0];
      const numValue = Number(firstPart);
      if (!isNaN(numValue) && numValue > 100) {
        return firstPart as string;
      }
    }
  }
  return undefined;
}
